import React from 'react'
import { useSelector } from 'react-redux'
import ProfileNav from '../components/navber/ProfileNav'
import Aviso from '../components/profile/Aviso'
import { Información } from '../components/profile/Información'
import Miplan from '../components/profile/Miplan'
import Prifel from '../components/profile/Prifel'
import ProfileLeft from '../components/profile/ProfileLeft'

const ProfilePage = () => {
  const {userprofiledata} = useSelector((state)=>state.auth)
  return (
    <>
      <ProfileNav/>
      <div>
        <div className='py-[50px]'></div>
        <div className='container'>
        <div className="flex items-start">
          <div className="flex-[1] hidden lg:block sticky top-[176px]">
            <ProfileLeft/>
          </div>
          <div className="lg:flex-[3] pt-10 pb-20">
            {userprofiledata === "profile" && <Prifel/>}
            {userprofiledata === "Información" && <Información/>}
            {userprofiledata === "Mi" && <Miplan/>}
            {userprofiledata === "Aviso" && <Aviso/>}
          </div>
        </div>
        </div>
    </div>
    </>
  )
}

export default ProfilePage